module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/ichiriki-649c6a370c0ad4141220deb327971506.jpg";